<template>
  <div class="container">
    <div class="mwow-detail-header">
      <div class="left">
        <div class="back-btn" @click="$router.go(-1)">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="mid">
        <p>学员退课</p>
      </div>
      <div class="right"></div>
    </div>
    <div style="margin: 0 60px">
      <div class="header-info block" style="margin: 14px 0 18px 0">
        <p class="title">退课信息</p>
        <div class="user">
          <span class="border">{{ studentData.name }}</span
          >{{ studentData.area_code ? "+" + studentData.area_code : "" }}
          {{ studentData.mobile }}
        </div>
      </div>
      <p class="tips" style="margin-bottom: 12px">
        统计退款课程已经耗课数、剩余课时数，可手动修改退课课时数，并根据单价自动计算金额。
      </p>
      <div class="table-wrap mwow-table">
        <div class="th row-11">
          <div class="td">订单号</div>
          <div class="td">业务形式</div>
          <div class="td">内容价格</div>
          <div class="td">购买课时</div>
          <div class="td">赠送课时</div>
          <div class="td">实收金额</div>
          <div class="td">耗课数</div>
          <div class="td">剩余金额</div>
          <div class="td">可退课时</div>
          <div class="td">退课课时</div>
          <div class="td">退课金额</div>
          <div class="td">
            手续费<el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
              width="240"
            >
              <p>
                门店根据规定在退/转课时收取额外费用，且手续费不可超过退课金额。
              </p>
              <i
                class="el-icon-question"
                slot="reference"
                style="
                  margin-left: 8px;
                  color: #bebfc0;
                  font-size: 16px;
                  vertical-align: text-bottom;
                "
              ></i>
            </el-popover>
          </div>
        </div>
        <div class="item" v-for="course in orderData" :key="course.item_id">
          <div class="title">
            <p class="text">【课程】- {{ course.product_name }}</p>
          </div>
          <div class="tr row-11">
            <div
              class="td"
              style="color: #07d1aa; cursor: pointer"
              @click="toOrderDetail(course)"
            >
              {{ course.order_no }}
            </div>
            <div class="td">-</div>
            <div class="td">{{ course.spec_name }}</div>
            <div class="td">
              {{ course.quantity }}
            </div>
            <div class="td">
              {{ course.give_product_quantity }}
            </div>
            <div class="td">￥{{ course.completed_amount }}</div>
            <div class="td">
              {{ course.item_course ? course.item_course.consume_number : "-" }}
            </div>
            <div class="td">
              <span v-if="course.item_course">
                ￥{{ course.item_course.usable_amount }}
              </span>
              <span v-else>-</span>
            </div>
            <div class="td">
              {{ course.item_course ? course.item_course.usable_number : "-" }}
            </div>
            <div class="td">
              <el-input
                v-model="course.refund_number"
                type="number"
                placeholder="请输入"
                style="width: 80%"
                class="red"
                :disabled="$route.query.complete === '0'"
                @change="handleRefundNumberChange(course)"
              ></el-input>
            </div>
            <div class="td">
              <span
                class="mwow-red"
                style="font-weight: 400"
                v-if="$route.query.complete === '0'"
                >￥{{ course.completed_amount }}</span
              >
              <span class="mwow-red" style="font-weight: 400" v-else
                >￥{{ solveCourseUseable(course) }}</span
              >
            </div>
            <div class="td">
              <el-input
                v-model="course.handling_fee"
                type="number"
                placeholder="请输入"
                style="width: 80%"
                class="red"
                @change="handleHandlingFeeChange(course)"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="sum-total-wrap" style="margin: 26px 30px">
        <div class="price">
          应退金额：<span class="mwow-green" style="margin-right: 24px"
            >￥{{ shouldRefund.toFixed(2) }}</span
          >
        </div>
      </div>
      <div class="block" v-if="!hasPaymentAuth">
        <p class="title">退款结算</p>
        <div class="pay-form-wrap">
          <div class="form mwow-form">
            <span class="label">退款方式：</span>
            <el-radio-group v-model="payTypeChecked">
              <el-radio
                border
                :label="item.key"
                v-for="item in payType"
                :key="item.key"
                size="mini"
                >{{ item.value }}</el-radio
              >
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="block">
        <p class="title">基本信息</p>
        <el-form
          size="mini"
          :model="staffForm"
          ref="staffForm"
          :rules="staffRules"
          label-width="72px"
        >
          <!-- 如果开通支付，不展示，旧逻辑保留 -->
          <el-form-item v-if="!hasPaymentAuth" label="退款时间:">
            <el-date-picker
              v-model="handle_time"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm"
              @change="changeHandle"
              :picker-options="disableOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="操作人员:">
            <div class="big-box">
              <div>{{ username }}</div>
              <div class="item">
                <span style="color: red">*&nbsp;</span>
                业务人员：<br />
                <div class="content belong-wrap">
                  <span
                    class="tag"
                    v-for="item in staffCheckedData"
                    :key="item.staff_id"
                    >{{ item.name }}</span
                  >
                  <addStaffDialog
                    :originData="staffCheckedData"
                    @change="addStaffChange"
                  >
                    <span class="btn">添加员工</span>
                  </addStaffDialog>
                </div>
              </div>
            </div>
          </el-form-item>
          <div
            style="color: #f56c6c; left: 208px; position: relative; top: -20px"
            v-show="showBusinessPerson"
          >
            请选择业务人员
          </div>
          <el-form-item label="退款原因:" prop="content">
            <el-input
              v-model="staffForm.content"
              placeholder="请输入"
              maxlength="250"
              type="textarea"
              rows="3"
              style="width: 60%"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="bottom-btns">
        <div
          class="mwow-button-filled mini"
          style="margin-right: 10px"
          @click="handleBack"
        >
          取消
        </div>
        <div class="mwow-button-filled success mini" @click="showConfirmDialog">
          保存
        </div>
      </div>
    </div>
    <el-dialog title="退款确认" :visible.sync="confirmDialogVisible">
      <div class="confirm-dialog">
        <div class="info-wrap">
          <p class="head">
            <span class="name">{{ studentData.name }}</span
            >{{ studentData.area_code ? "+" + studentData.area_code : "" }}
            {{ studentData.mobile }}
          </p>
          <div class="table">
            <div class="th">
              <div class="td">购买课时</div>
              <div class="td">赠送课时</div>
              <div class="td">耗课数</div>
              <div class="td">剩余金额</div>
              <div class="td">退课课时</div>
              <div class="td">退课金额</div>
              <div class="td">手续费</div>
            </div>
            <div class="item" v-for="course in orderData" :key="course.item_id">
              <p class="title">【课程】- {{ course.product_name }}</p>
              <div class="tr">
                <div class="td">
                  {{ course.quantity }}
                </div>
                <div class="td">
                  {{ course.give_product_quantity }}
                </div>
                <div class="td">
                  {{
                    course.item_course ? course.item_course.consume_number : "-"
                  }}
                </div>
                <div class="td">
                  <span v-if="course.item_course"
                    >￥{{ course.item_course.usable_amount }}</span
                  >
                  <span v-else>-</span>
                </div>
                <div class="td mwow-red">{{ course.refund_number }}</div>
                <div class="td mwow-red">
                  ￥{{ solveCourseUseable(course) }}
                </div>
                <div class="td mwow-red">￥{{ course.handling_fee }}</div>
              </div>
            </div>
          </div>
          <p class="sum-wrap">
            应退金额：<span class="red">￥{{ shouldRefund.toFixed(2) }}</span>
          </p>
        </div>
        <div class="pay-info">
          <p v-show="!hasPaymentAuth">
            退款方式：<span
              class="tag"
              v-for="(item, index) in payType.filter(
                (i) => payTypeChecked === i.key
              )"
              :key="index"
              >{{ item.value }}</span
            >
          </p>
        </div>
        <div class="warning-info">
          <i class="el-icon-warning"></i
          >请仔细核对信息，避免填写错误，提交后订单则不可修改。
        </div>
        <div class="bottom-btns">
          <div class="mwow-button-filled mini" @click="hideConfirmDialog">
            取消
          </div>
          <div class="mwow-button-filled success mini" @click="confirmSubmit">
            保存
          </div>
        </div>
      </div>
    </el-dialog>
    <approve-tips-dialog
      :visible.sync="approveDialogVisible"
      :order-id="orderId"
    ></approve-tips-dialog>
  </div>
</template>
<script>
import approveTipsDialog from "@/components/approveTipsDialog.vue";
import { solveLargeNumber } from "@/utils/common";
import { getPayment, expendItemDetailApi, lessonRefundApi } from "@/api/order";
import { UserModule } from "@/store/module/user";
import addStaffDialog from "@/components/addStaffDialog.vue";
// $route.query.complete订单是否完整支付：0否1是
export default {
  components: {
    approveTipsDialog,
    addStaffDialog,
  },
  data() {
    return {
      studentData: {},
      hasPaymentAuth: false, // 门店是否开通支付功能
      canDirectRefund: false, // 订单是否支持原路退还，不能原路退还时需要填写银行卡信息
      orderData: [],
      staffForm: {
        content: "",
      },
      handle_time: "", //经办时间/支付时间
      staffRules: {
        content: [
          { required: true, message: "请输入退款原因", trigger: "change" },
        ],
      },
      payType: [], // 门店支持的支付方式
      payTypeChecked: "",
      confirmDialogVisible: false,
      approveDialogVisible: false,
      orderId: 0,
      staffCheckedData: [], // 选中业务人员
      showBusinessPerson: false, // 是否选择业务人员
      isCash: false, // 是否为现金支付
      orderPaymentList: [], // 订单支付时使用的支付方式
      disableOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  computed: {
    username() {
      return UserModule.userInfo.staff_name;
    },
    // 应退金额
    shouldRefund() {
      let res = 0;
      this.orderData.map((course) => {
        res =
          (solveLargeNumber(res) +
            solveLargeNumber(this.solveCourseUseable(course)) -
            solveLargeNumber(course.handling_fee)) /
          100;
      });
      return res;
    },
  },
  created() {
    this.todayTime(); // 默认选中当天日期时间;
    const iid = String(this.$route.query.item_ids)
      .split(",")
      .map((id) => {
        return Number(id);
      });
    const sid = Number(this.$route.query.sid);
    if (iid && sid) {
      expendItemDetailApi({
        item_ids: iid,
        student_id: sid,
      }).then((res) => {
        if (res.data.list.length > 0) {
          this.studentData = res.data.student;
          res.data.list.map((item) => {
            if (this.$route.query.complete === "1") {
              item.refund_number = "1";
            } else {
              item.refund_number = item.quantity;
            }
            item.handling_fee = "0";
          });
          let sample = res.data.list[0];
          this.orderPaymentList = sample.payment_list;
          this.canDirectRefund = sample.refund_original_support;
          sample.payment_list.forEach((item) => {
            // 是否为现金支付
            if (item.payment_name === "现金") {
              this.isCash = true;
            }
          });
        }
        this.orderData = res.data.list;
      });
    }
    getPayment().then((res) => {
      if (res.error_code === 0) {
        const arr = [];
        res.data.list.map((item) => {
          if (item.key !== 5) {
            // 过滤POS机
            arr.push({
              ...item,
              checked: false,
              total: 0,
            });
          }
        });
        this.payType = arr;
        this.hasPaymentAuth = res.data.online_pay;
      }
    });
  },
  methods: {
    addStaffChange(val) {
      this.staffCheckedData = val;
      if (this.staffCheckedData.length) {
        this.showBusinessPerson = false;
      } else {
        this.showBusinessPerson = true;
      }
    },
    changeHandle(e) {
      this.todayTime(e.getTime()); // 修改时间
    },
    todayTime(t) {
      if (!t) {
        const date = new Date();
        this.gethandleTime(date);
      } else {
        const date = new Date(t);
        this.gethandleTime(date);
      }
    },
    gethandleTime(date) {
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const mm = m < 10 ? "0" + m : m;
      const d = date.getDate();
      const dd = d < 10 ? "0" + d : d;
      const H = date.getHours();
      const HH = H < 10 ? "0" + H : H;
      const M = date.getMinutes();
      const MM = M < 10 ? "0" + M : M;
      const S = date.getSeconds();
      const SS = S < 10 ? "0" + S : S;
      const time = y + "-" + mm + "-" + dd + " " + HH + ":" + MM + ":" + SS;
      this.handle_time = time;
    },
    solveCourseUseable(course) {
      let max = 0;
      if (Number(this.$route.query.complete) === 0) {
        // 分期付款
        max = Number(course.completed_amount);
      }
      if (Number(this.$route.query.complete) === 1) {
        // 后端要求四舍五入
        let a = Number(
          (Number(course.unit_price) * Number(course.refund_number)).toFixed(2)
        );
        max =
          a > Number(course.item_course.usable_amount)
            ? Number(course.item_course.usable_amount)
            : a;
      }
      return max;
    },
    handleRefundNumberChange(course) {
      if (
        Number(course.refund_number) > Number(course.item_course.usable_number)
      ) {
        this.$message({
          type: "warning",
          message: "退课课时不可大于可退课时",
        });
        course.refund_number = course.item_course.usable_number;
      } else if (Number(course.refund_number) < 0) {
        this.$message({
          type: "warning",
          message: "退课课时不可小于0",
        });
        course.refund_number = "0";
      } else {
        course.refund_number = Number(course.refund_number).toFixed(2);
      }
      course.handling_fee = "0";
    },
    handleHandlingFeeChange(course) {
      let max = this.solveCourseUseable(course);
      if (Number(course.handling_fee) > max) {
        this.$message({
          type: "warning",
          message: "手续费不可超过可退金额",
        });
        course.handling_fee = "0";
      } else if (Number(course.handling_fee) < 0) {
        this.$message({
          type: "warning",
          message: "手续费不可小于0",
        });
        course.handling_fee = "0";
      } else {
        course.handling_fee = Number(course.handling_fee).toFixed(2);
      }
    },
    showConfirmDialog() {
      // 业务人员验证
      if (this.staffCheckedData.length === 0) {
        this.showBusinessPerson = true;
        return;
      } else {
        this.showBusinessPerson = false;
      }
      // 未开通线上支付，并且没选择退款方式
      if (!this.hasPaymentAuth && !this.payTypeChecked) {
        this.$message({
          type: "warning",
          message: "请选择退款方式",
        });
        return;
      }
      this.$refs["staffForm"].validate((valid) => {
        if (valid) {
          this.confirmDialogVisible = true;
        }
      });
    },
    hideConfirmDialog() {
      this.confirmDialogVisible = false;
    },
    confirmSubmit() {
      const params = {
        student_id: Number(this.$route.query.sid),
        items: this.orderData.map((c) => {
          return {
            item_id: c.item_id,
            refund_quantity: c.refund_number || "0",
            should_refund_amount: (
              (solveLargeNumber(this.solveCourseUseable(c)) -
                solveLargeNumber(c.handling_fee)) /
              100
            ).toFixed(2),
            handling_fee: c.handling_fee, // 分期支付时，后端只处理手续费，其他不填也可以
          };
        }),
        remark: this.staffForm.content,
        handle_time: this.handle_time,
      };
      if (this.hasPaymentAuth) {
        if (!this.canDirectRefund) {
          // 无法原路退回时，需要手动填写银行卡相关信息
          params.refund_transfer = {
            // bank_name: this.cardForm.bank_name,
            // bank_card: this.cardForm.no,
            // open_bank: this.cardForm.sign_bank,
            // card_holder_name: this.cardForm.name,
          };
        }
      } else {
        // 旧流程要传支付方式，以前多选，订单分期版本改为单选
        params.payment_methods = this.orderData.map((c) => {
          return {
            payment_method_id: this.payTypeChecked,
            amount: (
              (solveLargeNumber(this.solveCourseUseable(c)) -
                solveLargeNumber(c.handling_fee)) /
              100
            ).toFixed(2),
          };
        });
      }
      if (this.staffCheckedData.length > 0) {
        const staff = [];
        this.staffCheckedData.map((item) => {
          staff.push(item.staff_id);
        });
        params.order_belong = staff;
      }
      lessonRefundApi(params).then((res) => {
        if (res.error_code === 0) {
          this.hideConfirmDialog();
          this.orderId = res.data.order_id;
          if (res.data.approval_id > 0) {
            // 提示审核
            this.approveDialogVisible = true;
          } else {
            this.$message({
              type: "success",
              message: "退课成功",
            });
            this.$router.replace({
              name: "orderManageDetail",
              query: {
                id: String(res.data.order_id),
              },
            });
          }
        } else if (res.error_code === 21001001) {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    handleBack() {
      this.$router.go(-1);
    },
    // 如果是退课、退单，跳转到原订单(购买课程订单)详情页
    toOrderDetail(val) {
      this.$router.push({
        name: "orderManageDetail",
        query: {
          ono: val.order_no,
          id: val.order_id,
        },
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "orderManageDetail") {
      let history = sessionStorage.getItem(
        "student_order_refund_route_history"
      );
      if (history) {
        let json = JSON.parse(history);
        if (json.student_id && json.buy_order_id) {
          sessionStorage.setItem(
            "student_order_refund_route_history",
            JSON.stringify({
              student_id: json.student_id,
              buy_order_id: json.buy_order_id,
              refund_order_id: this.orderId,
            })
          );
        }
      }
    }
    next();
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
}
.header-info {
  position: relative;
  .user {
    font-size: 16px;
    color: #5c5d5e;
    margin-left: 24px;
    .border {
      padding-right: 10px;
      margin-right: 10px;
      border-right: 1px solid #e7e8ea;
      font-weight: bold;
    }
    .mobile {
      font-weight: 400;
    }
  }
}
.block {
  border: 1px solid #d9dadb;
  border-radius: 4px;
  padding: 26px;
  margin-bottom: 26px;
  color: #5c5d5e;
  font-size: 12px;
  .title {
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 21px;
    font-weight: bold;
  }
}
.tips {
  font-size: 12px;
  line-height: 14px;
  color: #ffb940;
}
.table-wrap {
  .no-data {
    font-size: 14px;
    text-align: center;
    color: #5c5d5e;
    padding: 12px;
  }
  .th {
    background-color: #f2f6fa;
    font-size: 12px;
    color: #5c5d5e;
    margin-bottom: 14px;
    display: flex;
    line-height: 42px;
    align-items: center;
    padding: 0 16px;
    font-weight: bold;
  }
  .item {
    border: 1px solid #e1e5e9;
    margin-bottom: 14px;
    .title {
      padding-left: 30px;
      background: #f2f6fa;
      display: flex;
      align-items: center;
      .text {
        line-height: 42px;
        font-size: 14px;
        color: #5c5d5e;
        font-weight: bold;
        flex: 12;
      }
    }
    .tr {
      font-weight: bold;
      color: #5c5d5e;
      font-size: 12px;
      display: flex;
      line-height: 42px;
      align-items: center;
      padding: 0 16px;
      /deep/.td {
        .el-input__inner {
          color: #f56c6c !important;
        }
      }
    }
  }
  .row-11 {
    .td:nth-child(1) {
      flex: 2;
      padding-left: 22px;
    }
    .td:nth-child(2) {
      flex: 1;
    }
    .td:nth-child(3) {
      flex: 1;
    }
    .td:nth-child(4) {
      flex: 1;
    }
    .td:nth-child(5) {
      flex: 1;
    }
    .td:nth-child(6) {
      flex: 1;
    }
    .td:nth-child(7) {
      flex: 1;
    }
    .td:nth-child(8) {
      flex: 1;
    }
    .td:nth-child(9) {
      flex: 1;
    }
    .td:nth-child(10) {
      flex: 1;
    }
    .td:nth-child(11) {
      flex: 1;
    }
    .td:nth-child(12) {
      flex: 1;
    }
  }
}
.sum-total-wrap {
  font-size: 18px;
  color: #5c5d5e;
  text-align: right;
  .price {
    font-weight: bold;
    display: inline-block;
    margin-left: 36px;
    font-size: 18px;
    line-height: 24px;
    span {
      line-height: 22px;
      font-size: 22px;
    }
  }
}
.pay-form-wrap {
  line-height: 28px;
  font-size: 12px;
  &.error {
    .box {
      &.active {
        border: 1px solid #f56c6c !important;
      }
    }
  }
  .flex {
    display: flex;
  }
  .form {
    font-size: 12px;
    color: #5c5d5e;
    .label {
      margin: 0 5px;
    }
    .box {
      display: inline-block;
      margin-right: 38px;
      border: 1px solid #e7e8ea;
      border-radius: 4px;
      padding: 0 8px;
      &.active {
        border-color: #07d1aa;
      }
      .text {
        margin: 0 8px;
      }
      .input {
        font-size: 12px;
        color: #5c5d5e;
        border: 0;
        width: 55px;
        text-align: right;
        background: none !important;
      }
    }
  }
}
.foot-btn-wrap {
  text-align: left;
  margin-bottom: 12px;
  .mwow-button-filled {
    margin-right: 10px;
  }
}
.confirm-dialog {
  .info-wrap {
    .head {
      font-size: 14px;
      color: #5c5d5e;
      margin: 0 0 20px 0;
      .name {
        font-weight: bold;
        padding-right: 12px;
        margin-right: 12px;
        border-right: 1px solid #e7e8ea;
      }
    }
    .table {
      font-size: 12px;
      color: #5c5d5e;
      line-height: 28px;
      text-align: left;
      .th,
      .tr {
        display: flex;
        padding-left: 28px;
        .td {
          flex: 1;
        }
      }
      .th {
        background-color: #f2f6fa;
        margin-bottom: 10px;
        .td {
          font-weight: bold;
        }
      }
      .tr {
        border-bottom: 1px solid #e1e5e9;
        &:last-child {
          border-bottom: 0;
        }
        .td {
        }
      }
      .item {
        margin-bottom: 10px;
        border: 1px solid #e1e5e9;
        .title {
          padding-left: 22px;
          font-weight: bold;
          background: #f2f6fa;
          text-align: left;
        }
      }
    }
    .sum-wrap {
      text-align: right;
      margin: 24px 0;
      font-size: 16px;
      font-weight: bold;
      .red {
        color: #f56c6c;
      }
    }
  }
  .pay-info {
    border-top: 1px solid #e7e8ea;
    margin: 0 -20px;
    p {
      padding: 0 20px;
      line-height: 24px;
      margin: 8px 0;
      font-size: 12px;
      color: #5c5d5e;
      .tag {
        border-right: 1px solid #e7e8ea;
        padding-right: 8px;
        margin-right: 8px;
        &:last-child {
          border-right: 0;
        }
      }
      .red {
        color: #f56c6c;
      }
      .refund-tag {
        font-size: 12px;
        width: 16px;
        height: 16px;
        background: #f56c6c;
        border-radius: 4px;
        line-height: 16px;
        text-align: center;
        color: #fff;
        display: inline-block;
        margin-left: 6px;
      }
    }
  }
  .warning-info {
    line-height: 40px;
    background-color: #fff7e9;
    font-size: 12px;
    color: #ffb940;
    text-align: center;
    margin: 0 -20px 21px -20px;
    i {
      margin-right: 8px;
      font-size: 16px;
      vertical-align: middle;
    }
  }
  .bottom-btns {
    text-align: right;
    .mwow-button-filled {
      margin-left: 12px;
    }
  }
}
.big-box {
  display: flex;
  align-items: flex-start;
  :nth-child(2) {
    flex: 1;
  }
  .item {
    display: inline-flex;
    line-height: 28px;
    margin-bottom: 12px;
    margin-left: 100px;
    font-size: 12px;
    color: #5c5d5e;
    .label {
      min-width: 70px;
    }
    .content {
      flex: 1;
      .red {
        color: #f56c6c;
      }
      &.error {
        .box {
          &.active {
            border: 1px solid #f56c6c !important;
          }
        }
      }
      .box {
        display: inline-block;
        margin-right: 38px;
        border: 1px solid #e7e8ea;
        border-radius: 4px;
        padding: 0 8px;
        &.active {
          border-color: #07d1aa;
        }
        .text {
          margin: 0 8px;
        }
        .input {
          font-size: 12px;
          color: #5c5d5e;
          width: 60px;
          border: 0;
        }
      }
    }
    .belong-wrap {
      .tag {
        display: inline-block;
        vertical-align: middle;
        background-color: #f6fafc;
        padding: 0 12px;
        border-radius: 4px;
        margin-right: 12px;
        white-space: nowrap;
        margin-bottom: 10px;
      }
      .btn {
        color: #07d1aa;
        cursor: pointer;
        white-space: nowrap;
      }
    }
  }
}
</style>
